"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultLanguage = void 0;
var preferredLanguage = navigator.languages ? navigator.languages[0] : navigator.language;
var defaultLanguage = preferredLanguage ? preferredLanguage.toLowerCase() : 'en-us';
exports.defaultLanguage = defaultLanguage;